<div class="line-blue" [ngClass]="{lineMoe:LoginMoe}"></div>
<div class="continer-header">
<div [ngClass]="{topHeaderRightContainer:!LoginMoe}">
    <div class="text">
 <img src="./assets/icons/logo_israel.svg" alt=""/>
    <div>
        <div>מדינת ישראל</div>
        <h2>{{textH2}}</h2>
        <!-- <app-navbar></app-navbar> -->
    </div>
</div>
</div>
<div class="headerActionBtns-desktopView" *ngIf="!LoginMoe" >
    <a class="buttonIcon" target="_blank" rel="noopener noreferrer" href="https://www.gov.il/he/Departments/Guides/accessibility_edu" title="">
        <div class="magnifierStyles">
            <img src="./assets/images/accessibility.png" alt="accessibility" width="15" height="19">
        </div>
        <span class="accessibility-title"> הצהרת נגישות </span>
    </a>
  </div>
<!-- <div class="nav-header">
    <span class="nav-btn">
        <img src="./assets/images/play-movie.svg" alt="">
        <span> סרטון הסברה</span>
    </span>
    <span class="nav-btn">
        <img src="./assets/images/play-movie.svg" alt="">
        <span> סרטון הסברה</span>
    </span>
</div> -->
    <span *ngIf="LoginMoe" class="supportPhone"><span class="textSupport">מרכז סיוע</span> 073-3932510</span>
</div>